/**
 * UWM protocol events that are not part of the shared `@uwm/host` constants.
 * Mirrors the UWM Loyalty external-link contract.
 */
export const UWM_MODULE_GET_EXTERNAL_LINKS = 'UWM_MODULE_GET_EXTERNAL_LINKS';
export const UWM_INIT_EXTERNAL_LINKS = 'UWM_INIT_EXTERNAL_LINKS';
